import Button from '../../components/button/Button'
import useScreenSize from '../../hooks/useScreenSize'
import { useEffect, useState } from 'react'
import branchIcon from '../../assets/icons/BranchIcon.svg'
import './studentFees.scss'
import crossIcon from '../../assets/icons/crossIcon.svg'
import BreadCrumbs from '../../components/breadcrumb/Breadcrumb'
import { ROUTES_PATH, UI_CONSTANT } from '../../utility/constants'
import { useDispatch, useSelector } from 'react-redux'
import {
  getStudentCourseDetails,
  getStudentPaymentDetails,
  handleStudentPayment,
} from '../../store/builders/student/student.builder'
import { convertDateFormat, downloadReceipt } from '../../utility/genricFunction'
import jsPDF from 'jspdf'
import AdminLogo from '../../assets/logo/admin-logo-img.png'
import Loader from '../../components/loader/Loader'
// import StudentFeeReceipt from '../../components/student/StudentFeeReceipt'

function StudentFees() {
  const dispatch = useDispatch()
  const screenSize = useScreenSize()
  const [openInstallmentList, setOpenInstallmentList] = useState(false)
  const [openOneShotList, setOpenOneShotList] = useState(false)
  const [disableInstallmet, setDisableInstallment] = useState(false)
  const [disableOnetime, setDisableOnetime] = useState(false)
  const { user } = useSelector((store) => {
    return store.auth
  })
  const { studentCourseDetails, studentPaymentDetails, loading } = useSelector((store) => {
    return store.student
  })

  // const [studentCourseDetails] = studentCourseDetails
  const studentIdData = user?.result?.studentId

  useEffect(() => {
    if (studentIdData) {
      dispatch(getStudentCourseDetails(studentIdData))
      dispatch(getStudentPaymentDetails(studentIdData))
    }
  }, [dispatch, studentIdData])

  const breadCrumbsArr = [
    {
      title: UI_CONSTANT.STUDENT_FEES.FEES,
      link: null,
    },
    {
      title: UI_CONSTANT.DASHBOARD,
      link: ROUTES_PATH.STUDENT_DASHBOARD,
    },
    {
      title: UI_CONSTANT.STUDENT_FEES.FEES,
      link: ROUTES_PATH.STUDENT_FEES,
    },
  ]

  useEffect(() => {
    const script = document.createElement('script')
    script.src = 'https://checkout.razorpay.com/v1/checkout.js'
    script.async = true
    script.onload = () => {
      console.log('Razorpay script loaded successfully')
    }
    script.onerror = () => {
      console.error('Failed to load the Razorpay script')
    }
    document.body.appendChild(script)

    return () => {
      document.body.removeChild(script)
    }
  }, [])

  function getOrdinal(n) {
    let ord = 'th'
    if (n % 10 == 1 && n % 100 != 11) {
      ord = 'st'
    } else if (n % 10 == 2 && n % 100 != 12) {
      ord = 'nd'
    } else if (n % 10 == 3 && n % 100 != 13) {
      ord = 'rd'
    }
    return n + ord
  }
  const StudentName = user?.result?.userData?.userName
  let dueDetails = studentPaymentDetails && studentPaymentDetails?.filter((val) => val?.paymentOn == null)

  useEffect(() => {
    if(studentPaymentDetails.length > 0){
    let type = studentPaymentDetails.map((e) => e.installmentNo)
    let checkInstallment = type.some(item => item.includes("Installment"))
    let checkOneTime = type.some(item => item.includes("Full payment"))
    if(checkOneTime && checkInstallment){
      setOpenOneShotList(true)
      setOpenInstallmentList(true)
    } if(checkInstallment){
      setOpenInstallmentList(true)
      setDisableInstallment(false)
      setDisableOnetime(true)
    } if(checkOneTime){
      setOpenOneShotList(true)
      setDisableOnetime(false)
      setDisableInstallment(true)
    }
  }
  },[studentPaymentDetails])
  return (
    <>
      {loading && <Loader loading={loading} />}
      {<Loader loading={loading} /> && (
        <div className={`course-list ${screenSize}`}>
          <div className='filter-bar-wraper'>
            <div className='subheader'>
              <BreadCrumbs breadCrumbsArr={breadCrumbsArr} />
            </div>
          </div>
          <div className='student-fees-group-parent'>
            <div>
              <div className='student-fees-badge-container'>
                <div className='mcq-badge'>{studentCourseDetails && studentCourseDetails[0]?.courseExamFormat[0].toUpperCase()}</div>
                {studentCourseDetails && studentCourseDetails[0]?.courseExamFormat[1] && (
                  <div className='mcq-badge'>{studentCourseDetails && studentCourseDetails[0]?.courseExamFormat[1].toUpperCase()}</div>
                )}
              </div>
              <div className='Introduction-title'>{studentCourseDetails && studentCourseDetails[0]?.courseName}</div>
            </div>
            <div>
              <p className='total-fees'> Total Fees</p>
              <p className='total-fees-price'>₹ {studentCourseDetails && studentCourseDetails[0]?.courseFees}</p>
            </div>
          </div>

          <div className='fees-installment-wrapper'>
            <div className='student-fees-installment-wrapper'>
              <div className='student-fees-installment'>
                <div>
                  <div className='Introduction-title'>OneShot Payment</div>
                  <div className='installment-sub-title'>The payment is made in one complete transaction.</div>
                </div>
                <div className='payNow-btn'>
                  {openOneShotList ? (
                    <img
                      className='close-installment-list-btn'
                      src={crossIcon}
                      onClick={() => {
                        setOpenOneShotList(false)
                      }}
                    />
                  ) : (
                    <Button
                      disabled={disableOnetime}
                      customClassName='btn-pay-now'
                      onClick={() => {
                        setOpenOneShotList(true)
                      }}
                    >
                      {UI_CONSTANT.PAY_NOW}
                    </Button>
                  )}
                </div>
              </div>
              {openOneShotList && (
                <div className='open-installment-details first-row-installment'>
                  {studentPaymentDetails?.length ? (
                    <>
                      {studentPaymentDetails[0]?.feesStructure == 'oneTime' &&
                        studentPaymentDetails[0]?.registrationAmount > 0 && (
                          <div className='installment-row'>
                            <div>
                              <p className='installment-title'>Registration Amount</p>
                              <p className='installment-price'>₹ {studentPaymentDetails[0]?.registrationAmount}.00</p>
                              <p className='installment-date'>
                                Paid at{' '}
                                {convertDateFormat(studentPaymentDetails[0]?.paymentOn || new Date().toISOString())}
                              </p>
                            </div>
                            <div className='fees-btn-group'>
                              <Button
                                customClassName='btn-paid-status btn-download-reciept'
                                variant='outlined'
                                onClick={() =>
                                  downloadReceipt({
                                    ...studentPaymentDetails[0],
                                    type: 'Registration',
                                  }, StudentName, dueDetails)
                                }
                              >
                                Download Receipt
                              </Button>
                              <Button disabled customClassName='btn-paid-status btn-fees-paid'>
                                {UI_CONSTANT.PAID}
                              </Button>
                            </div>
                          </div>
                        )}

                      {studentPaymentDetails
                        ?.filter((e) => e.installmentNo == 'Full payment' && e.installmentNo !== 'registration')
                        .map((courseDetails, index) => (
                          <div
                            className={
                              studentPaymentDetails?.length - 1 === index
                                ? 'installment-row last-first-row-installment'
                                : 'installment-row'
                            }
                            key={index}
                          >
                            <div>
                              <p className='installment-title '>{`${courseDetails?.installmentNo}`}</p>
                              <p className='installment-price'>₹ {courseDetails?.payment}.00</p>
                              <p className='installment-date'>
                                {courseDetails?.paymentOn ? 'Paid at ' : 'Payment due at '}
                                {courseDetails?.paymentOn
                                  ? convertDateFormat(courseDetails?.paymentOn)
                                  : convertDateFormat(courseDetails?.paymentDue)}
                              </p>
                            </div>
                            <div className='fees-btn-group'>
                              {courseDetails.paymentOn && (
                                <Button
                                  customClassName='btn-paid-status btn-download-reciept'
                                  variant='outlined'
                                  onClick={() =>
                                    downloadReceipt({
                                      ...courseDetails,
                                      totalAmount: courseDetails?.payment,
                                    }, StudentName, dueDetails)
                                  }
                                >
                                  Download Receipt
                                </Button>
                              )}
                              <Button
                                onClick={() => {
                                  dispatch(
                                    handleStudentPayment({
                                      studentPaymentId: courseDetails?.studentPaymentId,
                                      studentId: courseDetails?.studentId,
                                      feesAmount: courseDetails?.payment,
                                      dispatch,
                                    }),
                                  )
                                }}
                                disabled={courseDetails?.paymentOn}
                                customClassName={
                                  courseDetails?.paymentOn ? 'btn-paid-status btn-fees-paid' : 'btn-paid-status'
                                }
                              >
                                {courseDetails?.paymentOn ? UI_CONSTANT.PAID : UI_CONSTANT.PAY_NOW}
                              </Button>
                            </div>
                          </div>
                        ))}
                    </>
                  ) : (
                    <div className='open-installment-details-text'>No record found</div>
                  )}
                </div>
              )}
            </div>

            <div
              className={
                openInstallmentList
                  ? 'student-fees-installment-wrapper student-fees-installment-open'
                  : 'student-fees-installment-wrapper'
              }
            >
              <div className='student-fees-installment '>
                <div>
                  <div className='Introduction-title'>Installment Payment</div>
                  <div className='installment-sub-title'>The payment is a series of scheduled, smaller payments.</div>
                </div>
                <div className='payNow-btn'>
                  {openInstallmentList ? (
                    <img
                      className='close-installment-list-btn'
                      src={crossIcon}
                      onClick={() => {
                        setOpenInstallmentList(false)
                      }}
                    />
                  ) : (
                    <Button
                      disabled={disableInstallmet}
                      customClassName='btn-pay-now'
                      onClick={() => {
                        setOpenInstallmentList(true)
                      }}
                    >
                      {UI_CONSTANT.PAY_NOW}
                    </Button>
                  )}
                </div>
              </div>
              {openInstallmentList && (
                <div className='open-installment-details first-row-installment'>
                  {studentPaymentDetails?.length ? (
                    <>
                      {studentPaymentDetails[0]?.feesStructure == 'installment' &&
                        studentPaymentDetails[0]?.registrationAmount > 0 && (
                          <div className='installment-row'>
                            <div>
                              <p className='installment-title'>Registration Amount</p>
                              <p className='installment-price'>₹ {studentPaymentDetails[0]?.registrationAmount}.00</p>
                              <p className='installment-date'>
                                Paid at{' '}
                                {convertDateFormat(studentPaymentDetails[0]?.paymentOn || new Date().toISOString())}
                              </p>
                            </div>
                            <div className='fees-btn-group'>
                              <Button
                                customClassName='btn-paid-status btn-download-reciept'
                                variant='outlined'
                                onClick={() =>
                                  downloadReceipt({
                                    ...studentPaymentDetails[0],
                                    type: 'Registration',
                                  }, StudentName, dueDetails)
                                }
                              >
                                Download Receipt
                              </Button>
                              <Button disabled customClassName='btn-paid-status btn-fees-paid'>
                                {UI_CONSTANT.PAID}
                              </Button>
                            </div>
                          </div>
                        )}

                      {studentPaymentDetails
                        .filter((e) => e.installmentNo !== 'Full payment' && e.installmentNo !== 'registration')
                        .map((courseDetails, index) => (
                          <div
                            className={
                              studentPaymentDetails?.length - 1 === index
                                ? 'installment-row last-first-row-installment'
                                : 'installment-row'
                            }
                            key={index}
                          >
                            <div>
                              <p className='installment-title '>{`${courseDetails?.installmentNo}`}</p>
                              <p className='installment-price'>₹ {courseDetails?.payment}.00</p>
                              <p className='installment-date'>
                                {courseDetails?.paymentOn ? 'Paid at ' : 'Payment due at '}
                                {courseDetails?.paymentOn
                                  ? convertDateFormat(courseDetails?.paymentOn)
                                  : convertDateFormat(courseDetails?.paymentDue)}
                              </p>
                            </div>
                            <div className='fees-btn-group'>
                              {courseDetails.paymentOn && (
                                <Button
                                  customClassName='btn-paid-status btn-download-reciept'
                                  variant='outlined'
                                  onClick={() =>
                                    downloadReceipt({
                                      ...courseDetails,
                                      totalAmount: courseDetails?.payment,
                                    }, StudentName, dueDetails)
                                  }
                                >
                                  Download Receipt
                                </Button>
                              )}
                              <Button
                                onClick={() => {
                                  dispatch(
                                    handleStudentPayment({
                                      studentPaymentId: courseDetails?.studentPaymentId,
                                      studentId: courseDetails?.studentId,
                                      feesAmount: courseDetails?.payment,
                                      dispatch,
                                    }),
                                  )
                                }}
                                disabled={courseDetails?.disabled}
                                customClassName={
                                  courseDetails?.paymentOn ? 'btn-paid-status btn-fees-paid' : 'btn-paid-status'
                                }
                              >
                                {courseDetails?.paymentOn ? UI_CONSTANT.PAID : UI_CONSTANT.PAY_NOW}
                              </Button>
                            </div>
                          </div>
                        ))}
                    </>
                  ) : (
                    <div className='open-installment-details-text'>No record found</div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      )}
    </>
  )
}

export default StudentFees
